import { cn } from '@/lib/utils';
import { FC, useState } from 'react';

type Props = {
	text: string;
	activated?: boolean;
	onClick: () => void;
};

const ETextColorPicker: FC<Props> = ({ text, activated, onClick }) => {
	return (
		<button
			onClick={onClick}
			className={cn(
				'w-full h-11 p-1 text-sm font-medium rounded-full border border-popover-100 hover:bg-primary-color-100 cursor-pointer',
				activated && 'border-2 border-popover-1000',
			)}>
			<div
				className={cn(
					'h-full bg-popover-50 rounded-full flex items-center justify-center',
					activated && 'text-popover-10 bg-popover-1000',
				)}>
				{text}
			</div>
		</button>
	);
};

export default ETextColorPicker;
